import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLink = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M16.944 7.058c.521.52.521 1.365 0 1.885l-8 8a1.333 1.333 0 0 1-1.886-1.885l8-8a1.335 1.335 0 0 1 1.886 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="m12.26 4.196-.583.676A1.333 1.333 0 1 1 9.659 3.13l.617-.715a8 8 0 1 1 11.38 11.244 1.365 1.365 0 0 1-.068.064l-.712.619a1.333 1.333 0 0 1-1.749-2.013l.675-.587a5.334 5.334 0 0 0-7.541-7.545Zm-.52 15.609.583-.676a1.333 1.333 0 1 1 2.018 1.743l-.617.715a1.31 1.31 0 0 1-.067.07A8 8 0 1 1 2.344 10.344c.022-.022.044-.044.068-.064l.712-.619a1.333 1.333 0 0 1 1.749 2.013l-.675.587a5.334 5.334 0 0 0 7.541 7.545Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLink);
export default ForwardRef;
